import {
  Box,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import JobSurveyItems from "./JobSurveyItems";

const LoadDataJobSheet = () => {
  const { leadDetails } = useSelector((state: any) => state.lead);
  const { surveyedItems, surveyedSummary } = useSelector(
    (state: any) => state.leadSurvey,
  );

  const materials =
    surveyedItems?.list?.find((item: any) => item.name === "Materials")
      ?.items || [];

  const resourceData =
  surveyedItems?.list
    ?.find((item: any) => item.name === "Resources")
    ?.items?.filter((item: any) => Number(item.quantity) > 0) || [];

  const movingFrom = surveyedSummary?.lead?.moving_from?.[0] ?? leadDetails?.lead?.collection_address?.[0];
  const movingTo = surveyedSummary?.lead?.moving_to?.[0] ?? leadDetails?.lead?.delivery_address?.[0];
  const movingFromVolume = Array.isArray(leadDetails?.lead?.collection_address)
    ? leadDetails.lead.collection_address
    : [];
  const formatAddress = (addr: any) => {
    if (!addr) return "";

    return `${addr.building_number || ""} ${addr.street || ""}
  ${addr.town || ""}, ${addr.county || ""}, ${addr.country || ""}
  ${addr.postcode || ""}`;
  };

  // Separate by flags
  const allSurveyedItems =
    surveyedItems?.list?.map((cat: any) => cat.items).flat() || [];

  const leaveItems = allSurveyedItems
    .filter((it: any) => it.isLeave && Number(it.quantity) > 0)
    .map((it: any) => `${it.item} X ${it.quantity}`);
  const weeeItems = allSurveyedItems
    .filter((it: any) => it.isWeee && Number(it.quantity) > 0)
    .map((it: any) => `${it.item} X ${it.quantity}`);
  const custItems = allSurveyedItems
    .filter((it: any) => it.isCust && Number(it.quantity) > 0)
    .map((it: any) => `${it.item} X ${it.quantity}`);

  const totalVolumeM3 = movingFromVolume?.reduce((sum: any, item: any) => {
    let volume = Number(item.volume) || 0;

    if (item.volume_unit === "ft3") {
      volume = volume * 0.0283168; // convert ft3 → m3
    }

    return sum + volume;
  }, 0);

  return (
    <Box
      sx={{
        maxWidth: "900px",
        margin: "0 auto",
        padding: "20px",
        fontFamily: "Times New Roman",
        fontSize: "13px",
      }}
    >
      {/* HEADER */}
      <Grid container spacing={2}>
        <Grid item xs={4}>
          <Typography fontWeight={600}>FUEL:</Typography>
        </Grid>

        <Grid item xs={4} textAlign="center">
          <Typography fontWeight={600}>NAME:</Typography>
          {leadDetails?.lead?.customer_name}
        </Grid>

        <Grid item xs={4} textAlign="right">
          <Typography fontWeight={600}>TELEPHONE:</Typography>
          {leadDetails?.lead?.customer_phone}
        </Grid>
      </Grid>

      <Grid container mt={2}>
        <Grid item xs={4}>
          <Typography fontWeight={600}>JOB TYPE:</Typography>
          LOAD
        </Grid>

        <Grid item xs={4} textAlign="center">
          <Typography fontWeight={600}>DATE:</Typography>
          {surveyedSummary?.lead?.removalDate
            ? dayjs(surveyedSummary?.lead?.removalDate)?.format("DD/MM/YYYY")
            : leadDetails?.lead?.moving_on_date
            ? dayjs(leadDetails?.lead?.moving_on_date)?.format("DD/MM/YYYY")
            : "N/A"}
        </Grid>

        <Grid item xs={4} textAlign="right">
          <Typography fontWeight={600}>TIME ON SITE:</Typography>
          
        </Grid>
      </Grid>

      {/* MOVING FROM / TO */}
      <Table sx={{ border: "1px solid black", mt: 2 }}>
        <TableBody>
          <TableRow>
            <TableCell sx={headerCell}>MOVING FROM</TableCell>
            <TableCell sx={headerCell}>MOVING TO</TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={cell}>
              {formatAddress(movingFrom)}
              <br />
              <b>Bedrooms:</b> {movingFrom?.house_size}
              <br />
              <b>Floors / Levels:</b> {movingFrom?.floors}
              <br />
              <b>Lift:</b> {movingFrom?.lift_availability}
              <br />
              <b>Type:</b> {movingFrom?.type}
              <br />
              <b>External Flights:</b> {movingFrom?.flight_of_stairs}
            </TableCell>

            <TableCell sx={cell}>
              {formatAddress(movingTo)}
              <br />
              <b>Bedrooms:</b> {movingTo?.house_size}
              <br />
              <b>Paces:</b> {movingTo?.paces}
              <br />
              <b>Floors / Levels:</b> {movingTo?.floors}
              <br />
              <b>Lift:</b> {movingTo?.lift_availability}
              <br />
              <b>Type:</b> {movingTo?.type}
              <br />
              <b>External Flights:</b> {movingTo?.flight_of_stairs}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>

      {/* PAYMENT METHOD */}
      <Table sx={{ border: "1px solid black", mt: 2 }}>
        <TableBody>
          <TableRow>
            <TableCell sx={headerCell} colSpan={3}>
              PAYMENT METHOD
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={cell} align="center">
              COLLECT CASH
            </TableCell>
            <TableCell sx={cell} align="center">
              NEEDS TO PAY BEFORE UNLOADING
            </TableCell>
            <TableCell sx={cell} align="center">
              PAID
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>

      {/* KEY WAITING */}
      <Table sx={{ border: "1px solid black", mt: 2 }}>
        <TableBody>
          <TableRow>
            <TableCell sx={cell}>KEY WAITING:</TableCell>
            <TableCell sx={cell}>HAS KEYS ON THE DAY</TableCell>
            <TableCell sx={cell}>GETTING KEYS ON THE DAY</TableCell>
          </TableRow>
        </TableBody>
      </Table>

      {/* ITEMS TO REASSEMBLE */}
      <Table sx={{ border: "1px solid black", mt: 2 }}>
        <TableBody>
          <TableRow>
            <TableCell sx={cell}>
              <b>ITEMS TO REASSEMBLE:</b>
              <br />
              {weeeItems.join(" | ")}
            </TableCell>

            <TableCell sx={cell}>
              <b>Furniture fixtures given to customer by:</b>
              <br />
              Customer signature: ___________________
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>

      {/* RESOURCES */}
      <Table sx={{ border: "1px solid black", mt: 2 }}>
        <TableBody>
          <TableRow>
            <TableCell sx={cell}>
              <b>RESOURCES REQUIRED:</b>
              <br />
              {resourceData?.length
                ? resourceData.map((mat: any, index: number) => (
                    <span key={index}>
                      {mat.item} X {mat.quantity}
                      <br />
                    </span>
                  ))
                : "N/A"}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>

      {/* CUSTOMER DISMANTLE */}
      <Table sx={{ border: "1px solid black", mt: 2 }}>
        <TableBody>
          <TableRow>
            <TableCell sx={cell}>
              <b>CUSTOMER DISMANTLE:</b> {custItems.join(" | ")}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>

      {/* DO NOT TAKE */}
      <Table sx={{ border: "1px solid black", mt: 2 }}>
        <TableBody>
          <TableRow>
            <TableCell sx={cell}>
              <b>DO NOT TAKE THESE ITEMS:</b> {leaveItems.join(" | ")}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>

      {/* CUSTOMER NOTES */}
      <Table sx={{ border: "1px solid black", mt: 2 }}>
        <TableBody>
          <TableRow>
            <TableCell sx={cell}>
              <b>CUSTOMER NOTES:</b>{" "} {surveyedSummary?.lead?.customerNotes || leadDetails?.lead?.customer_notes}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
      <JobSurveyItems />
      {/* TOTAL VOLUME */}
      <Table sx={{ border: "1px solid black", mt: 2 }}>
        <TableBody>
          <TableRow>
            <TableCell sx={cell}>
              <b>TOTAL VOLUME: {totalVolumeM3.toFixed(2)} m3</b>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Box>
  );
};

export default LoadDataJobSheet;

const cell = {
  border: "1px solid black",
  padding: "6px",
};

const headerCell = {
  border: "1px solid black",
  padding: "6px",
  fontWeight: 600,
};
